import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Provider, useSelector } from "react-redux";
import { getCompanyId } from "../../../react-reduxs/slices/auth/auth_slice";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Switch,
} from "antd";
import { MenuCategoryModel } from "../../../services/menu_categories/models/menu_category.model";
import { MenuProductModel } from "../../../services/menu_products/models/menu_product.model";
import Title from "antd/es/typography/Title";
import CompManagerMenuCategoryAdd from "../menu_categories/CompManagerMenuCategoryAdd";
import FileUploadComponent from "../../tests/FileUploadComponent";
import { getCompany } from "../../../react-reduxs/slices/companies/company_slice";
import { store } from "../../../react-reduxs/configure_store";
import MenuProductServcie from "../../../services/menu_products/menu_product.service";
import { ApiUrl } from "../../../consts/api";
import { FileUploadService } from "../../../services/file_uploads/file_upload.service";
import { PrinterModel } from "../../../services/printers/models/printer.model";
import { PrinterService } from "../../../services/printers/printer.service";
import { AllergenService } from "../../../services/allergens/allergen.service";
import { AllergenModel } from "../../../services/allergens/models/allergen.model";

import AntAllergenListBox from "./AntAllergenListBox";
import { CreateUpdateMenuProductDto } from "../../../services/menu_products/models/create_update_menu_product.dto";
import { GetMenuProductByIdResponse } from "../../../services/menu_products/models/get_menu_product_by_id.response";

interface CompManagerMenuProductAddProps {
  closeModal: () => void;
  categoryList: MenuCategoryModel[];
  saveProduct: (value: any) => void;
  saveCategory: (value: MenuCategoryModel) => Promise<void>;
  deleteMenuProductImage: (
    menuProductModel: CreateUpdateMenuProductDto,
    imagePath: string,
  ) => Promise<MenuProductModel | undefined>;
  id: string;
  productService: MenuProductServcie;
  isLoading: boolean;
}
const CompManagerMenuProductAdd: React.FC<CompManagerMenuProductAddProps> = ({
  categoryList,
  saveProduct,
  saveCategory,
  closeModal,
  id,
  productService,
  deleteMenuProductImage,
  isLoading,
}) => {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [printerList, setPrinterList] = useState<PrinterModel[]>([]);
  const [allergenList, setAllergenList] = useState<AllergenModel[]>([]);
  const modalInstance = useRef<any>();
  const menuProductModel = useRef<GetMenuProductByIdResponse>();
  const printerService = useMemo(() => new PrinterService(), []);
  const fileUploadService = useMemo(() => new FileUploadService(), []);
  const allergenService = useMemo(() => new AllergenService(), []);
  const companyId = useSelector(getCompanyId);
  const company = useSelector(getCompany);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [form] = Form.useForm();
  const getProduct = useCallback(async () => {
    let response = await productService.getById(id);

    if (response) {
      menuProductModel.current = response;
      form.setFieldValue("id", response.id);
      form.setFieldValue("menuCategoryId", response.menuCategoryId);
      form.setFieldValue("price", response.price);
      form.setFieldValue("title", response.title);
      form.setFieldValue(
        "allergenicInformation",
        response.allergenicInformation,
      );
      form.setFieldValue("calorie", response.calorie);
      form.setFieldValue("fat", response.fat);
      form.setFieldValue("carbohydrate", response.carbohydrate);
      form.setFieldValue("protein", response.protein);
      form.setFieldValue("detail", response.detail);
      form.setFieldValue("timeToGetReady", response.timeToGetReady);
      form.setFieldValue("status", response.status);
      form.setFieldValue("printerId", response.printerId);
      form.setFieldValue("allergens", response.allergens ?? []);
      setImageUrl(response.photo ?? "");
    }
  }, [form, id, productService]);
  const getPrinterList = useCallback(async () => {
    const response = await printerService.getList(companyId);
    if (response) {
      setPrinterList(response);
    }
  }, [printerService, companyId]);
  const getAllergens = useCallback(async () => {
    const response = await allergenService.getList();
    if (response) {
      setAllergenList(response);
    }
  }, [allergenService]);
  const initLoad = useCallback(async () => {
    setLoading(true);
    await Promise.all([getPrinterList(), getAllergens()]);
    console.error(id);

    if (id !== "") {
      await getProduct();
    }
    setLoading(false);
  }, [getPrinterList, getProduct, id, getAllergens]);

  const onFinish = async (values: any) => {
    if (companyId) {
      setLoading(true);
      await saveProduct({
        companyId: companyId,
        photo: imageUrl === "" ? undefined : imageUrl,
        id: values.id == "" ? null : values.id,
        printerId: values.printerId == "" ? null : values.printerId,
        ...values,
      });
      setLoading(false);
      setImageUrl("");
      closeModal();
    }
  };

  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    setCount((co) => {
      if (co === 0) {
        initLoad();
      }
      return 1;
    });

    return () => {};
  }, [company, fileUploadService, initLoad, imageUrl]);

  return (
    <div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row style={{ gap: 3 }}>
          <Col flex={1}>
            <Title style={{ lineHeight: 0 }} level={3}>
              Ürün Ekle
            </Title>
            <Form.Item
              style={{ position: "relative", height: 0 }}
              name="id"
              label=""
            >
              <Input placeholder="" style={{ display: "none" }} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="status" label="" initialValue={true}>
              <Switch checkedChildren="Aktif" unCheckedChildren="Pasif" />
            </Form.Item>
          </Col>
        </Row>

        <Row style={{ gap: 3 }}>
          <Col>
            <Col flex={1}>
              {menuProductModel.current?.photo !== "" &&
              menuProductModel.current?.photo !== undefined ? (
                <div>
                  <Button
                    size="small"
                    style={{ position: "absolute", left: 80 }}
                    loading={isLoading}
                    onClick={async () => {
                      if (menuProductModel.current) {
                        console.error(menuProductModel.current);

                        if (
                          menuProductModel.current.photo !== undefined &&
                          menuProductModel.current.photo !== ""
                        ) {
                          let response = await deleteMenuProductImage(
                            {
                              id: menuProductModel.current.id,
                              companyId: menuProductModel.current.companyId,
                              menuCategoryId:
                                menuProductModel.current.menuCategoryId,
                              price: menuProductModel.current.price,
                              title: menuProductModel.current.title,
                              allergenicInformation:
                                menuProductModel.current.allergenicInformation,
                              calorie: menuProductModel.current.calorie,
                              detail: menuProductModel.current.detail,
                              timeToGetReady:
                                menuProductModel.current.timeToGetReady,
                              status: menuProductModel.current.status,
                              printerId: menuProductModel.current.printerId,
                              photo: menuProductModel.current.photo,
                              allergens: menuProductModel.current.allergens,
                            } as CreateUpdateMenuProductDto,
                            menuProductModel.current.photo ?? "",
                          );
                          if (response) {
                            setImageUrl("");
                            menuProductModel.current.photo = "";
                          }
                        }
                      }
                    }}
                    danger
                    icon={<i className="fa-duotone fa-trash"></i>}
                  />
                  <img
                    width={110}
                    height={110}
                    src={ApiUrl + "/" + imageUrl}
                    alt=""
                  />
                </div>
              ) : (
                <FileUploadComponent
                  path={"Companies/" + company?.folderName + "/Products"}
                  setImageUrlParam={setImageUrl}
                  setDeleteImageParam={setDeleteStatus}
                />
              )}
            </Col>
          </Col>
          <Col flex={1}>
            <Form.Item name="title" label="Adı" rules={[{ required: true }]}>
              <Input placeholder="Adı" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item name="price" label="Fiyat" rules={[{ required: true }]}>
              <InputNumber style={{ minWidth: 150 }} placeholder="Fiyat" />
            </Form.Item>
          </Col>

          <Col span={16}>
            <Form.Item
              name="menuCategoryId"
              label="Kategori "
              rules={[{ required: true }]}
            >
              <Select
                placeholder=" "
                style={{ width: "100%", minWidth: 150 }}
                options={categoryList.map((item) => ({
                  value: item.id,
                  label: item.name,
                }))}
              />
            </Form.Item>
          </Col>

          <Col
            flex={1}
            style={{ display: "flex", alignItems: "center", paddingTop: 7 }}
          >
            <Button
              loading={isLoading}
              disabled={isLoading}
              onClick={() => {
                modalInstance.current = Modal.info({
                  footer: <></>,
                  content: (
                    <Provider store={store}>
                      <CompManagerMenuCategoryAdd
                        isLoading={isLoading}
                        saveCategory={saveCategory}
                        modalClose={() => {
                          modalInstance.current?.destroy();
                        }}
                      />
                    </Provider>
                  ),
                });
              }}
              icon={<i className="fa-duotone fa-plus"></i>}
            >
              Kategori Ekle
            </Button>
          </Col>
          <Col span={24}>
            <Form.Item name="printerId" label="Yazıcı ">
              <Select
                placeholder=" "
                style={{ width: "100%", minWidth: 150 }}
                options={[
                  {
                    label: "Yazıcı Yok",
                    value: "",
                  },
                  ...printerList.map((item) => ({
                    value: item.id,
                    label: item.name,
                  })),
                ]}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="calorie" label="Kalori">
              <InputNumber
                placeholder="Kalori"
                onChange={(e) => {
                  if (e == null) {
                    form.setFieldValue("calorie", 0);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="fat" label="Yağ">
              <InputNumber
                placeholder="Yağ"
                onChange={(e) => {
                  if (e == null) {
                    form.setFieldValue("fat", 0);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="carbohydrate" label="Karbonhidrat">
              <InputNumber
                placeholder="Karbonhidrat"
                onChange={(e) => {
                  if (e == null) {
                    form.setFieldValue("carbohydrate", 0);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item name="protein" label="Protein">
              <InputNumber
                placeholder="Protein"
                onChange={(e) => {
                  if (e == null) {
                    form.setFieldValue("protein", 0);
                  }
                }}
              />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item
              name="timeToGetReady"
              label="Hazırlanma zamanı"
              initialValue={""}
            >
              <Input placeholder="Hazırlanma zamanı" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="detail" label="Detay" initialValue={""}>
              <Input.TextArea placeholder="Detay" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="allergens"
              label="Alerjen Bilgisi"
              initialValue={[]}
            >
              <AntAllergenListBox allergenList={allergenList} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Item>
              <Space>
                <Button
                  disabled={isLoading}
                  loading={isLoading}
                  type="primary"
                  htmlType="submit"
                >
                  Kaydet
                </Button>
              </Space>
            </Form.Item>
          </Col>
          <Col style={{ paddingLeft: 10 }}>
            <Button
              disabled={deleteStatus}
              danger
              htmlType="button"
              onClick={() => {
                closeModal();
              }}
            >
              İptal
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CompManagerMenuProductAdd;
